import { render, staticRenderFns } from "./SubjectRow.vue?vue&type=template&id=84a6c24c&scoped=true&"
import script from "@/components/subject-row/SubjectRow.ts?vue&type=script&lang=ts&"
export * from "@/components/subject-row/SubjectRow.ts?vue&type=script&lang=ts&"
import style0 from "./subject-row.scss?vue&type=style&index=0&id=84a6c24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a6c24c",
  null
  
)

export default component.exports